<template>
  <div id="archive-warehouse-users">
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active" aria-current="page">{{ translations('shipping_instruction.warehouse_users') }}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap">
          <div class="form-group mr-2">
            <button v-if="isAdmin" class="btn btn-primary" type="button" @click="openSingleUser()">{{ translations('common.addition') }}</button>
          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1500 table-clickable table-no-margin"
          item-key="name"
          :headers="translationHeaders"
          :items="users"
          hide-default-footer
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
              <tr v-for="(item, i) in items" :key='i' data-href="" @click="openSingleUser(item)">
                <td>{{ item.name }}</td>
                <td>{{ item.email }}</td>
                <td>
                  <span v-for="(warehouse, j) in item.warehouses" :key="j">
                    {{ j > 0 ? ', ' : '' }}
                    {{ warehouse.name }}
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </div>
    <vue-element-loading :active="isLoading" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveWarehouseUsers',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      headers: [
        { text: 'ユーザー名', value: 'name' },
        { text: 'メールアドレス', value: 'email' },
        { text: '倉庫名', value: 'warehouse_name' }
      ],
      isLoading: false,
      users: []
    }
  },
  created: function () {
    this.getUsers()
  },
  computed: {
    ...mapState(['currentLanguage']),
    isAdmin: function () {
      return this.$store.getters['User/isAdmin']
    },
    translationHeaders () {
      return this.headers.map(header => ({
        ...header,
        text: this.translations(`shipping_instruction.${header.value}`)
      }))
    }
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getUsers () {
      this.isLoading = true

      this.$http.post(this.$api_url.warehouse_users).then(response => {
        const result = response.data
        if (result.status === true) {
          this.users = result.list
        } else {
          this.users = []
          this.$toastr.error(result, 'エラー')
        }
      }).catch(e => {
        console.log('ArchiveWarehouseUsers:API:getUsers: error: ', e)
        this.$toastr.error('エラーのため失敗しました。ご確認後、再試行してください。', 'エラー')
      }).finally(() => {
        this.isLoading = false
      })
    },

    openSingleUser (user = null) {
      if (!this.isAdmin) {
        this.$toastr.warning('管理者のみ編集できます。')
        return
      }
      if (user) {
        this.$router.push({ name: 'single-warehouse-users', query: { user_id: user.id } })
      } else {
        this.$router.push({ name: 'single-warehouse-users' })
      }
    }
  }
}
</script>
